import { AxiosInstance } from 'axios';
import { DataFetcherResponse } from '@/compiler/types';
import baseAxios from '@/helpers/forms/axios';
import type { PlatformOauthAccountType } from './platformOauth';
import type { PartnerAppStatus } from './platformOauthPartnerApps';

export interface PlatformOauthConnectionClient {
    id: string
    name: string
    description: string | null
    logoUrl: string | null
    websiteUrl: string | null
    status: PartnerAppStatus
}

export interface PlatformOauthConnection {
    id: string
    client: PlatformOauthConnectionClient
    scopes: string[]
    createdAt: string
    updatedAt: string
}

const connectionsUrls: Record<PlatformOauthAccountType, string> = {
    service_provider: '/api/platform-oauth/connections/service-providers',
    merchant: '/api/platform-oauth/connections/merchants',
};

export default (axios: AxiosInstance = baseAxios): {
    fetchConnections: (accountType: PlatformOauthAccountType, page: number, perPage: number, signal?: AbortSignal) => Promise<DataFetcherResponse<PlatformOauthConnection>>
    revokeConnection: (accountType: PlatformOauthAccountType, grantId: string) => Promise<void>
} => ({
    fetchConnections: async (accountType: PlatformOauthAccountType, page: number, perPage: number, signal?: AbortSignal): Promise<DataFetcherResponse<PlatformOauthConnection>> => {
        const response = await axios.get<DataFetcherResponse<PlatformOauthConnection>>(connectionsUrls[accountType], {
            params: { page, perPage },
            signal,
        });

        return response.data;
    },

    revokeConnection: async (accountType: PlatformOauthAccountType, grantId: string): Promise<void> => {
        await axios.delete(`${connectionsUrls[accountType]}/${encodeURIComponent(grantId)}`);
    },
});
